import { aclService } from './service'
import { getProtectedPermissions } from './permissions'
import Vue from 'vue'

var md5 = require('md5')

class ResourceBase {
  constructor () {
    this.defaultPermissions = {}
    this.permissions = {}
  }

  async create () {
    for (let behavior in this.permissions) {
      if (this.permissions.hasOwnProperty(behavior)) {
        const path = this.permissions[behavior].path
        const displayName = this.permissions[behavior].displayName
        const description = this.permissions[behavior].description
        let tag = 'normal'
        if (this.permissions[behavior].hasOwnProperty('tag')) {
          tag = this.permissions[behavior].tag
        }
        await aclService.createResource({ path, displayName, description, tag })
      }
    }
  }

  get_acl () {
    const acls = []
    for (let behavior in this.permissions) {
      if (this.permissions.hasOwnProperty(behavior)) {
        const path = this.permissions[behavior].path
        const displayName = this.permissions[behavior].displayName
        const description = this.permissions[behavior].description
        let tag = 'normal'
        if (this.permissions[behavior].hasOwnProperty('tag')) {
          tag = this.permissions[behavior].tag
        }
        const tenantId = 2
        const serviceName = 'labeling'
        acls.push({ tenantId, serviceName, path, displayName, description, tag })
      }
    }
    return acls
  }

  get_step_acl (behaviors) {
    let acls = []
    for (let behavior in this.permissions) {
      if (behaviors.includes(behavior) && this.permissions.hasOwnProperty(behavior)) {
        const path = this.permissions[behavior].path
        const displayName = this.permissions[behavior].displayName
        const description = this.permissions[behavior].description
        let tag = 'normal'
        if (this.permissions[behavior].hasOwnProperty('tag')) {
          tag = this.permissions[behavior].tag
        }
        const tenantId = 2
        const serviceName = 'labeling'
        acls.push({ tenantId, serviceName, path, displayName, description, tag })
      }
    }
    return acls
  }

  async createStepAcl (behaviors) {
    for (let behavior in this.permissions) {
      if (behaviors.includes(behavior) && this.permissions.hasOwnProperty(behavior)) {
        const path = this.permissions[behavior].path
        const displayName = this.permissions[behavior].displayName
        const description = this.permissions[behavior].description
        let tag = 'normal'
        if (this.permissions[behavior].hasOwnProperty('tag')) {
          tag = this.permissions[behavior].tag
        }
        await aclService.createResource({ path, displayName, description, tag })
      }
    }
  }

  check (behavior) {
    if (behavior in this.permissions) {
      const accountResourceAcl = JSON.parse(Vue.localStorage.get('accountResourceAcl'))
      if (accountResourceAcl.hasOwnProperty('directResourceAcl')) {
        return accountResourceAcl.directResourceAcl.includes(this.permissions[behavior].path)
      } else {
        return false
      }
    }
    return true
  }
}

class Workspaces extends ResourceBase {
  constructor () {
    super()
    this.baseResourcePath = `workspaces`
    this.defaultPermissions = {
      'create': {
        'displayName': `创建工作区权限`,
        'path': this.baseResourcePath + '.create',
        'description': `创建工作区权限`
      }
    }
    this.permissions = getProtectedPermissions('Workspaces', this.defaultPermissions)
  }
}

class Workspace extends ResourceBase {
  constructor ({ workspace }) {
    super()
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.baseResourcePath = `workspace.${this.workspaceId}`
    this.defaultPermissions = {
      'read': {
        'displayName': `工作区-${this.workspace}-使用权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-使用权限`
      },
      '_step_': {
        'displayName': `工作区-${this.workspace}-步骤-基础权限`,
        'path': `workspace.${this.workspaceId}.step`,
        'description': `工作区-${this.workspace}-步骤-基础权限`,
        'tag': 'virtual'
      },
      'release': {
        'displayName': `工作区-${this.workspace}-发布权限`,
        'path': this.baseResourcePath + '.release',
        'description': `工作区-${this.workspace}-发布权限`
      },
      'download': {
        'displayName': `工作区-${this.workspace}-下载权限`,
        'path': this.baseResourcePath + '.download',
        'description': `工作区-${this.workspace}-下载权限`
      },
      'delete': {
        'displayName': `工作区-${this.workspace}-删除权限`,
        'path': this.baseResourcePath + '.delete',
        'description': `工作区-${this.workspace}-删除权限`
      }
    }
    this.permissions = getProtectedPermissions('Workspace', this.defaultPermissions)
  }
}

// todo
class Files extends ResourceBase {
  constructor ({ workspace }) {
    super()
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.baseResourcePath = `workspace.${this.workspaceId}.files`
    this.defaultPermissions = {
      '_root_': {
        'displayName': `工作区-${this.workspace}-文件-基本权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-文件-基本权限`,
        'tag': 'virtual'
      },
      'upload': {
        'displayName': `工作区-${this.workspace}-文件-上传权限`,
        'path': this.baseResourcePath + '.upload',
        'description': `工作区-${this.workspace}-文件-上传权限`
      },
      'delete': {
        'displayName': `工作区-${this.workspace}-文件-删除权限`,
        'path': this.baseResourcePath + '.delete',
        'description': `工作区-${this.workspace}-文件-删除权限`
      }
    }
    this.permissions = getProtectedPermissions('Files', this.defaultPermissions)
  }
}

class Step extends ResourceBase {
  constructor ({ workspace, step }) {
    super()
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.step = step
    this.stepId = md5(step)
    this.baseResourcePath = `workspace.${this.workspaceId}.step.${this.stepId}`
    this.defaultPermissions = {
      'read': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-阅读权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-步骤-${this.step}-阅读权限`
      }
    }
    this.permissions = getProtectedPermissions('Step', this.defaultPermissions)
  }
}

class Tags extends ResourceBase {
  constructor ({ workspace, step }) {
    super({ workspace, step })
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.step = step
    this.stepId = md5(step)
    this.baseResourcePath = `workspace.${this.workspaceId}.step.${this.stepId}.tags`
    this.defaultPermissions = {
      '_root_': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标签基本权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-步骤-${this.step}-标签基本权限`,
        'tag': 'virtual'
      },
      'management': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标签管理权限`,
        'path': this.baseResourcePath + '.management',
        'description': `工作区-${this.workspace}-步骤-${this.step}-标签管理权限`
      },
      'create': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标签创建权限`,
        'path': this.baseResourcePath + '.create',
        'description': `工作区-${this.workspace}-步骤-${this.step}-标签创建权限`
      },
      'delete': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标签删除权限`,
        'path': this.baseResourcePath + '.delete',
        'description': `工作区-${this.workspace}-步骤-${this.step}-标签删除权限`
      }
    }
    this.permissions = getProtectedPermissions('Tags', this.defaultPermissions)
  }
}

class Labeling extends ResourceBase {
  constructor ({ workspace, step }) {
    super({ workspace, step })
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.step = step
    this.stepId = md5(step)
    this.baseResourcePath = `workspace.${this.workspaceId}.step.${this.stepId}.labeling`
    this.defaultPermissions = {
      'read': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标注读权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-步骤-${this.step}-标注读权限`
      },
      'write': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标注写权限`,
        'path': this.baseResourcePath + '.write',
        'description': `工作区-${this.workspace}-步骤-${this.step}-标注写权限`
      },
      'skip': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-跳过标注权限`,
        'path': this.baseResourcePath + '.write.skip',
        'description': `工作区-${this.workspace}-步骤-${this.step}-跳过标注权限`
      },
      'help': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-模型辅助标注使用权限`,
        'path': this.baseResourcePath + '.help',
        'description': `工作区-${this.workspace}-步骤-${this.step}-模型辅助标注使用权限`
      },
      'save': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标注保存权限`,
        'path': this.baseResourcePath + '.save',
        'description': `工作区-${this.workspace}-步骤-${this.step}-标注保存权限`
      },
      'signoff': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-标注签订权限`,
        'path': this.baseResourcePath + '.signoff',
        'description': `工作区-${this.workspace}-步骤-${this.step}-标注签订权限`
      }
    }
    this.permissions = getProtectedPermissions('Labeling', this.defaultPermissions)
  }
}

class Models extends ResourceBase {
  constructor ({ workspace, step }) {
    super({ workspace, step })
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.step = step
    this.stepId = md5(step)
    this.baseResourcePath = `workspace.${this.workspaceId}.step.${this.stepId}.models`
    this.defaultPermissions = {
      'read': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-模型列表阅读权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-步骤-${this.step}-模型列表阅读权限`
      },
      'select': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-模型选择权限`,
        'path': this.baseResourcePath + '.select',
        'description': `工作区-${this.workspace}-步骤-${this.step}-模型选择权限`
      },
      'infer': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-模型使用权限`,
        'path': this.baseResourcePath + '.infer',
        'description': `工作区-${this.workspace}-步骤-${this.step}-模型使用权限`
      }
    }
    this.permissions = getProtectedPermissions('Models', this.defaultPermissions)
  }
}

class TrainingTasks extends ResourceBase {
  constructor ({ workspace, step }) {
    super({ workspace, step })
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.step = step
    this.stepId = md5(step)
    this.baseResourcePath = `workspace.${this.workspaceId}.step.${this.stepId}.training_tasks`
    this.defaultPermissions = {
      'read': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-训练任务列表阅读权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-步骤-${this.step}-训练任务列表阅读权限`
      },
      'create': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-创建训练任务权限`,
        'path': this.baseResourcePath + '.create',
        'description': `工作区-${this.workspace}-步骤-${this.step}-创建训练任务权限`
      },
      'classify': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-文件-训练集验证集分类权限`,
        'path': this.baseResourcePath + '.classify',
        'description': `工作区-${this.workspace}-步骤-${this.step}-文件-训练集验证集分类权限`
      },
      'weight': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-文件-文件权重调整权限`,
        'path': this.baseResourcePath + '.weight',
        'description': `工作区-${this.workspace}-步骤-${this.step}-文件-文件权重调整权限`
      }
    }
    this.permissions = getProtectedPermissions('TrainingTasks', this.defaultPermissions)
  }
}

class Results extends ResourceBase {
  constructor ({ workspace, step }) {
    super({ workspace, step })
    this.workspace = workspace
    this.workspaceId = md5(workspace)
    this.step = step
    this.stepId = md5(step)
    this.baseResourcePath = `workspace.${this.workspaceId}.step.${this.stepId}.results`
    this.defaultPermissions = {
      '_root_': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-结果基本权限`,
        'path': this.baseResourcePath,
        'description': `工作区-${this.workspace}-步骤-${this.step}-结果基本权限`,
        'tag': 'virtual'
      },
      'import': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-结果导入权限`,
        'path': this.baseResourcePath + '.import',
        'description': `工作区-${this.workspace}-步骤-${this.step}-结果导入权限`
      },
      'write': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-结果写权限`,
        'path': this.baseResourcePath + '.write',
        'description': `工作区-${this.workspace}-步骤-${this.step}-结果写权限`
      },
      'save': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-结果保存权限`,
        'path': this.baseResourcePath + '.save',
        'description': `工作区-${this.workspace}-步骤-${this.step}-结果保存权限`
      },
      'export': {
        'displayName': `工作区-${this.workspace}-步骤-${this.step}-结果导出权限`,
        'path': this.baseResourcePath + '.export',
        'description': `工作区-${this.workspace}-步骤-${this.step}-结果导出权限`
      }
    }
    this.permissions = getProtectedPermissions('Results', this.defaultPermissions)
  }
}

const ResourcesClass = {
  Workspaces,
  Workspace,
  Files,
  Step,
  Tags,
  Labeling,
  TrainingTasks,
  Models,
  Results
}

class Resource {
  constructor (className, opts) {
    return new ResourcesClass[className](opts)
  }
}

export default Resource
